var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "graduationProve" }, [
    _c(
      "div",
      { staticClass: "graduationProve-box" },
      [
        _c("Title", { attrs: { text: "毕业证明书" } }),
        _c(
          "div",
          { staticClass: "top-btn" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.goToPage } },
              [_vm._v("毕业证明书申请记录")]
            ),
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "info",
            staticClass: "demo-ruleForm modify-ruleForm",
            attrs: { model: _vm.infoData, rules: _vm.infoRules },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 60 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学生姓名", prop: "student_title" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入学生姓名",
                            clearable: "",
                          },
                          model: {
                            value: _vm.infoData.student_title,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "student_title", $$v)
                            },
                            expression: "infoData.student_title",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "身份证", prop: "identity" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入身份证", clearable: "" },
                          model: {
                            value: _vm.infoData.identity,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "identity", $$v)
                            },
                            expression: "infoData.identity",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学号", prop: "student_code" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入学号", clearable: "" },
                          model: {
                            value: _vm.infoData.student_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "student_code", $$v)
                            },
                            expression: "infoData.student_code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "考生号", prop: "candidate_number" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入考生号", clearable: "" },
                          model: {
                            value: _vm.infoData.candidate_number,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "candidate_number", $$v)
                            },
                            expression: "infoData.candidate_number",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "函授站", prop: "school_data" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择函授站",
                              clearable: "",
                              filterable: "",
                            },
                            on: { change: _vm.schoolChange },
                            model: {
                              value: _vm.infoData.school_data,
                              callback: function ($$v) {
                                _vm.$set(_vm.infoData, "school_data", $$v)
                              },
                              expression: "infoData.school_data",
                            },
                          },
                          _vm._l(_vm.schoolList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.title,
                                value: item.id + "-" + item.title,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "班级", prop: "class_title" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入班级", clearable: "" },
                          model: {
                            value: _vm.infoData.class_title,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "class_title", $$v)
                            },
                            expression: "infoData.class_title",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学制层次", prop: "level_data" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择学制层次",
                              clearable: "",
                              filterable: "",
                            },
                            on: { change: _vm.levelChange },
                            model: {
                              value: _vm.infoData.level_data,
                              callback: function ($$v) {
                                _vm.$set(_vm.infoData, "level_data", $$v)
                              },
                              expression: "infoData.level_data",
                            },
                          },
                          _vm._l(_vm.levelList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.title,
                                value: item.id + "-" + item.title,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "专业", prop: "profession_data" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择专业",
                              clearable: "",
                              filterable: "",
                            },
                            on: { change: _vm.professionChange },
                            model: {
                              value: _vm.infoData.profession_data,
                              callback: function ($$v) {
                                _vm.$set(_vm.infoData, "profession_data", $$v)
                              },
                              expression: "infoData.profession_data",
                            },
                          },
                          _vm._l(_vm.professionList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.title,
                                value: item.id + "-" + item.title,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "联系电话", prop: "tel" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入联系电话",
                            clearable: "",
                          },
                          model: {
                            value: _vm.infoData.tel,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "tel", $$v)
                            },
                            expression: "infoData.tel",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "原毕业证书编号",
                          prop: "old_cert_code",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入原毕业证书编号",
                            clearable: "",
                          },
                          model: {
                            value: _vm.infoData.old_cert_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "old_cert_code", $$v)
                            },
                            expression: "infoData.old_cert_code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "入学时间", prop: "entrance_date" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            format: "yyyy-MM",
                            "value-format": "yyyy-MM",
                            placeholder: "请选择入学时间",
                          },
                          model: {
                            value: _vm.infoData.entrance_date,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "entrance_date", $$v)
                            },
                            expression: "infoData.entrance_date",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "毕业时间", prop: "grad_date" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            format: "yyyy-MM",
                            "value-format": "yyyy-MM",
                            placeholder: "请选择毕业时间",
                          },
                          model: {
                            value: _vm.infoData.grad_date,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "grad_date", $$v)
                            },
                            expression: "infoData.grad_date",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学习形式", prop: "shape_title" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择学习形式",
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.infoData.shape_title,
                              callback: function ($$v) {
                                _vm.$set(_vm.infoData, "shape_title", $$v)
                              },
                              expression: "infoData.shape_title",
                            },
                          },
                          _vm._l(_vm.shapeList, function (item) {
                            return _c("el-option", {
                              key: item,
                              attrs: { label: item, value: item },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "身份证正面照(人像面)",
                          prop: "card_img_just_data",
                        },
                      },
                      [
                        _c("uploadFile", {
                          ref: "uploadCardImgJust",
                          attrs: {
                            fileLists: _vm.infoData.card_img_just_data,
                            isShowModal: false,
                          },
                          on: {
                            handleChange: function ($event) {
                              return _vm.upLoadImg($event, "card_img_just")
                            },
                            handleRemove: function ($event) {
                              return _vm.handleRemove($event, "card_img_just")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "身份证反面照(国徽面)",
                          prop: "card_img_back_data",
                        },
                      },
                      [
                        _c("uploadFile", {
                          ref: "uploadCardImgBack",
                          attrs: {
                            fileLists: _vm.infoData.card_img_back_data,
                            isShowModal: false,
                          },
                          on: {
                            handleChange: function ($event) {
                              return _vm.upLoadImg($event, "card_img_back")
                            },
                            handleRemove: function ($event) {
                              return _vm.handleRemove($event, "card_img_back")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "学籍档案照片",
                          prop: "archives_img_data",
                        },
                      },
                      [
                        _c("uploadFile", {
                          ref: "uploadArchivesImg",
                          attrs: {
                            fileLists: _vm.infoData.archives_img_data,
                            isShowModal: false,
                          },
                          on: {
                            handleChange: function ($event) {
                              return _vm.upLoadImg($event, "archives_img")
                            },
                            handleRemove: function ($event) {
                              return _vm.handleRemove($event, "archives_img")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "证件照", prop: "inch_img_data" } },
                      [
                        _c("uploadFile", {
                          ref: "uploadInchImg",
                          attrs: {
                            fileLists: _vm.infoData.inch_img_data,
                            isShowModal: false,
                          },
                          on: {
                            handleChange: function ($event) {
                              return _vm.upLoadImg($event, "inch_img")
                            },
                            handleRemove: function ($event) {
                              return _vm.handleRemove($event, "inch_img")
                            },
                          },
                        }),
                        _c("p", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            "请上传蓝底证件照的电子档，大小20-40k，尺寸480*640."
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "申请书照片", prop: "apply_img_data" },
                      },
                      [
                        _c("uploadFile", {
                          ref: "uploadApplyImg",
                          attrs: {
                            fileLists: _vm.infoData.apply_img_data,
                            isShowModal: false,
                          },
                          on: {
                            handleChange: function ($event) {
                              return _vm.upLoadImg($event, "apply_img")
                            },
                            handleRemove: function ($event) {
                              return _vm.handleRemove($event, "apply_img")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "申请原因", prop: "apply_remark" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            placeholder: "请输入申请原因",
                            maxlength: "200",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.infoData.apply_remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "apply_remark", $$v)
                            },
                            expression: "infoData.apply_remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "btn-box" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.submitInfo } },
              [_vm._v("提交")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }